var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide",class:[_vm.fill, _vm.size, { 'has-icon': _vm.$slots.icon }]},[(_vm.$slots.icon)?_c('span',{staticClass:"icon"},[_vm._t("icon")],2):_vm._e(),(_vm.template)?_c('TemplateRenderer',{staticClass:"content",attrs:{"node":_vm.templateRootNode,"slots":_vm.$slots}}):_c('div',{staticClass:"content"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }